<div class="row">
    <div class="col-sm-12 text-center hero-head"><a routerLink="/"><img width="250" src="../../assets/logo.png" alt="logo"></a></div>
</div>
<div class="row">
    <div class="col-sm-12 drop-user text-center">
        <div [ngClass]="{'show': showDropUser}" class="dropdown">
            <button (click)="showDropUser=!showDropUser" class="user-toggle" type="button" >
             {{ username }}
             <i class="fa fa-chevron-down"></i>
            </button>
            <div [ngClass]="{'show': showDropUser}" class="dropdown-menu m-auto" aria-labelledby="dropdownMenuButton">
              <a class="dropdown-item" routerLink="/profile">My Profile</a>
              <a (click)="logOut()" class="dropdown-item">LogOut</a>
            </div>
          </div>
    </div>
</div>
<div class="row">
    <div class="col-sm-12">
        <app-all-playlist></app-all-playlist>
    </div>
</div>

